<template>
  <div class="cart-item">
    <div class="p-2 flex items-center justify-between bg-secondary">
      <div>{{ data.game.league.name_ko }}</div>
      <QBtn
        icon="close"
        outline
        dense
        round
        @click="cartStore.selectSportItem(data)"
      />
    </div>
    <div class="px-2 py-3 grid grid-cols-12 bg-gradient-to-b from-dark-3 to-dark-2">
      <div class="col-span-9 flex flex-col gap-2">
        <div class="w-full flex flex-nowrap items-center gap-2">
          <div class="max-w-1/2 truncate">
            {{ data.game.home_team.name_ko }}
          </div>
          <div>VS</div>
          <div class="max-w-1/2 truncate">
            {{ data.game.away_team.name_ko }}
          </div>
        </div>
        <div class="w-full flex flex-nowrap items-center gap-2 ">
          <div class="truncate">
            {{ data.market.name_ko }}
          </div>
        </div>
        <div class="w-full flex flex-nowrap items-center gap-2">
          <template v-if="props.data.participant.argument">
            <div class="max-w-1/2 truncate">
              {{ data.participant.argument }}
            </div>
            <div>—</div>
          </template>
          <div class="max-w-1/2 truncate">
            {{ name }}
          </div>
        </div>
      </div>
      <div
        class="col-span-3 odds-value"
        :class="{'animated flash slow infinite':animated}"
      >
        <template v-if="locked">
          <QIcon name="lock" />
        </template>
        <template v-else>
          {{ value }}
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useOdds } from '@/composables/useOdds.js'
import { useCartStore } from '@/stores/cart.js'
import { ref, watch } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})

const { name, value, locked } = useOdds(() => props.data.odds, props.data.game)

const cartStore = useCartStore()

const animated = ref(false)
watch(() => props.data.odds, (oldVal, newVal) => {
  if (oldVal.v !== newVal.v && newVal.locked === 0) {
    animated.value = true
    setTimeout(() => {
      animated.value = false
    }, 2000)
  }
})
</script>
